<template>
    <div class="">
        <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full">
                <label class="vs-input--label">{{ $t('wifi.branch') }}</label>
                <v-select :clearable="false" class="w-full" :options="branchList" v-model="branchOptionModel"
                    name="branch"></v-select>
            </div>
            <div class="vx-col md:w-2/3 w-full flex">
                <!--                <vs-button class="mt-6" @click="getDataScheduleWorkshift" icon-pack="feather" icon="icon-search">-->
                <!--                    Tìm kiếm-->
                <!--                </vs-button>-->
                <vs-button class="mt-6 ml-auto" @click="addSchedule" icon-pack="feather" icon="icon-plus" type="border"
                    v-if="isPermissionAdd()">{{ $t('button.add') }}
                </vs-button>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full mt-2" style="min-height:300px">
                <vs-table :data="workshifts" :max-items="10" :pagination="workshifts.length > 0"
                    noDataText="Không có dữ liệu">
                    <template slot="thead">
                        <vs-th class="border text-center bg-primary text-white" v-for="(header, index) in headers"
                            :key="index">
                            <div class="w-full">
                                <span>{{ header }}</span>
                            </div>
                        </vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :key="index" v-for="(item, index) in data">
                            <vs-td class="text-center">
                                {{ item.name }}
                            </vs-td>
                            <vs-td class="text-center">
                                {{ item.startTime }}
                            </vs-td>
                            <vs-td class="text-center">
                                {{ item.endTime }}
                            </vs-td>
                            <vs-td class="text-center">
                                <div :style="{ 'background-color': item.colorCode }"
                                    style="min-width:100px;height:20px;border-radius:5px"></div>
                            </vs-td>
                            <vs-td class="text-center">
                                <feather-icon svgClasses='h-4 w-4 hover:text-success cursor-pointer' icon-pack="feather"
                                    icon="EditIcon" @click="editSchedule(item)"
                                    v-if="isPermissionUpdate()"></feather-icon>
                                <feather-icon svgClasses='h-4 w-4 hover:text-danger cursor-pointer ml-3'
                                    icon-pack="feather" icon="TrashIcon" @click="removeSchedule(item)"
                                    v-if="isPermissionDelete()"></feather-icon>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </div>
        <vs-popup :title="isUpdate ? 'Cập nhật ca giảng dạy' : 'Tạo mới ca giảng dạy'" :active.sync="activePopup">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <label class="font-bold" style="font-size:16px">{{ $t('dashboard.configureEmployeeWorkSchedules') }}</label>
                    <div class="vx-row mt-4">
                        <div class="vx-col w-full">
                            <label>{{ $t('wifi.branch') }} <span class="text-danger">*</span></label>
                            <v-select class="w-full" :options="branchList" v-model="branchModel" name="branch"
                                v-validate="'required'" :clearable="false"></v-select>
                            <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                        </div>
                        <div class="vx-col w-full md:w-5/12 mt-4">
                            <label>{{ $t('menuOrganization.department') }} <span class="text-danger">*</span></label>
                            <v-select :clearable="false" class="w-full" :options="listWorkShift"
                                v-model="workshiftModel" name="workshiftType" v-validate="'required'"></v-select>
                            <span class="text-danger text-sm">{{ errors.first('workshiftType') }}</span>
                        </div>
                        <div class="vx-col w-full mt-4">
                            <vs-input class="w-full" v-model="teachingSchedule.description"
                                label="Chú thích"></vs-input>
                        </div>
                        <!--                        <div class="vx-col w-full mt-4">-->
                        <!--                            <label class="font-bold" style="font-size:16px">Chọn màu ca dạy <span-->
                        <!--                                class="text-danger">*</span></label>-->
                        <!--                            <div class="vx-row pl-5">-->
                        <!--                                <div class="m-1 mt-2 cursor-pointer" v-for="(color, index) in colors" :key="color.id">-->
                        <!--                                    <div style="width: 20px;height: 20px;border-radius: 4px"-->
                        <!--                                         :style="{ 'background-color': color.hex, 'width':color.style,'height':color.style}"-->
                        <!--                                         :class="'cursor-pointer_' + index"-->
                        <!--                                         @click="selectedColor(color, index)"-->
                        <!--                                    >-->
                        <!--                                    </div>-->
                        <!--                                </div>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                    </div>
                    <div class="vx-row mt-4">
                        <div class="w-full vx-col" v-if="!isUpdate">
                            <label class="font-bold" style="font-size:16px">{{ $t('minioStorage.CheckTeachingTime') }}</label>
                            <v-select :clearable="false" class="w-full" :options="selectedWork" v-model="modelWork"
                                @input="changeDate" name="branch"></v-select >
                        </div>
                        <div class="vx-col w-full mt-2" v-if="this.selectTime ">
                            <label>{{ $t('workShift.startTime') }} <span class="text-danger">*</span></label>
                            <vs-input v-validate="'required'" name="startTime" type="time" class="w-full"
                                v-model="teachingSchedule.startTime"></vs-input>
                            <span class="text-danger text-sm">{{ errors.first('startTime') }}</span>
                        </div>
                        <div class="vx-col w-full mt-2" v-if="this.selectTime">
                            <label>{{ $t('workShift.endTime') }} <span class="text-danger">*</span></label>
                            <vs-input name="endTime" v-validate="'required'" type="time" class="w-full"
                                v-model="teachingSchedule.endTime"></vs-input>
                            <span class="text-danger text-sm">{{ errors.first('startTime') }}</span>
                        </div>
                        <div class="vx-col w-full mt-2" v-if="!this.selectTime">
                            <label>{{ $t('workShift.startTime') }} <span class="text-danger">*</span></label>
                            <vs-input v-validate="'required'" name="startTime" type="time" class="w-full"
                                v-model="computedStartTime"></vs-input>
                            <span class="text-danger text-sm">{{ errors.first('startTime') }}</span>
                        </div>
                        <div class="vx-col w-full mt-2" v-if="!this.selectTime">
                            <label>{{ $t('workShift.endTime') }} <span class="text-danger">*</span></label>
                            <vs-input name="endTime" v-validate="'required'" type="time" class="w-full"
                                v-model="computedEndTime"></vs-input>
                            <span class="text-danger text-sm">{{ errors.first('startTime') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mt-4">
                        <div class="vx-col w-full flex">
                            <vs-button class="ml-auto" @click="saveChanges" :disabled="!validateForm">
                                {{isUpdate ? $t('button.update') : $t('button.create') }}
                            </vs-button>
                            <vs-button class="ml-4" @click="activePopup = false">{{ $t('button.back') }}</vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import { isAPI, isRouter } from '../../../store/permission';
import { constAPI, constRouter } from '../../../store/constant';
import DateRangePicker from '../../../components/vue2-daterange-picker/components/DateRangePicker.vue'

export default {
    components: {
        vSelect,
        DateRangePicker
    },
    data() {
        return {
            dateRange: {
                endDate: new Date(),
                startDate: new Date(new Date().setHours(0, 0, 0))
            },
            branchList: [],
            branchListOptions: [],
            listWorkShift: [
                { value: 'HCTH', label: 'Hành chính tổng hợp', color: '#FFEB3B' },
                { value: 'QLDT', label: 'Quản lí đào tạo', color: '#FF9800' },
                { value: 'KT', label: 'Kế toán', color: '#007AFE' },
                { value: 'DH', label: 'Du học', color: '#81C784' },
                { value: 'lX', label: 'Lái xe', color: '#29CC97' },
                { value: 'TTSK', label: 'Truyền thông sự kiện', color: '#29CC97' },
            ],
            selectedWork: [
                { value: 0, label: 'Cả ngày' },
                { value: 1, label: 'Nửa ngày' },
            ],
            modelWork:   { value: 0, label: 'Cả ngày' },
            selectTime: false,
            teachingId: null,
            activePopup: false,
            workshifts: [],
            headers: ['Tên ca dạy', 'Thời gian bắt đầu', 'Thời gian kết thúc', 'Màu sắc', 'Hành động'],
            isUpdate: false,
            teachingSchedule: {
                colorCode: null,
                type: 0,
                // startTime:'',
                // endTime:'',
            },
            colors: [
                {
                    id: '1',
                    hex: '#007AFE',
                    style: '20px'
                },
                // {
                // id: '2',
                // hex: '#BAD9FB',
                // style:'20px'
                // },
                {
                    id: '3',
                    hex: '#F12B2C',
                    style: '20px'
                }, {
                    id: '4',
                    hex: '#EA5455',
                    style: '20px'
                }, {
                    id: '5',
                    hex: '#FF3D54',
                    style: '20px'
                }, {
                    id: '6',
                    hex: '#27AE60',
                    style: '20px'
                }, {
                    id: '7',
                    hex: '#28C76F',
                    style: '20px'
                }, {
                    id: '8',
                    hex: '#29CC97',
                    style: '20px'
                }, {
                    id: '9',
                    hex: '#F28A2D',
                    style: '20px'
                }, {
                    id: '10',
                    hex: '#FF9F43',
                    style: '20px'
                }, {
                    id: '11',
                    hex: '#FEC400',
                    style: '20px'
                },
                // {
                // id: '12',
                // hex: '#FEEA70',
                // style:'20px'
                // },
            ],
            workshift: {
                valueWorkshift: null,
                organizationBranchId: null,
                type: 0
            },
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any()
        },
        workshiftModel: {
            get() {
                let object = this.listWorkShift.find(el => el.value === this.workshift.valueWorkshift);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(object) {
                this.workshift.valueWorkshift = object ? object.value : null
            }
        },
        branchModel: {
            get() {
                let object = this.branchList.find(el => el.value == this.teachingSchedule.organizationBranchId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(object) {
                this.teachingSchedule.organizationBranchId = object ? object.value : null;
            }
        },
        branchOptionModel: {
            get() {
                let object = this.branchListOptions.find(el => el.value == this.workshift.organizationBranchId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(object) {
                this.workshift.organizationBranchId = object ? object.value : null;
                this.getDataScheduleWorkshift();
            }
        },
        computedStartTime: {
            get() {
                return this.teachingSchedule.startTime || '08:00';
            },
            set(value) {
                // this.teachingSchedule.startTime = value;
                this.$set(this.teachingSchedule, 'startTime', value);
            }
        },
        computedEndTime: {
            get() {
                return this.teachingSchedule.endTime || '17:30';
            },
            set(value) {
                this.$set(this.teachingSchedule, 'endTime', value);
            }
        }
    },
    mounted() {
    if (!this.teachingSchedule.startTime) {
      this.$set(this.teachingSchedule, 'startTime', '08:00');
    }
    if (!this.teachingSchedule.endTime) {
      this.$set(this.teachingSchedule, 'endTime', '17:30');
    }
  },
    methods: {
        changeDate() {
            this.selectTime = this.modelWork.value
            if (this.selectTime === 0){
                this.teachingSchedule.startTime = '08:00',
                this.teachingSchedule.endTime = '17:30'
            } else {
                this.teachingSchedule.startTime = '',
                this.teachingSchedule.endTime = ''
            }


            console.log(this.selectTime)
        },
        isPermissionAdd() {
            return isAPI(this, constAPI.teaching_schedule_add)
        },
        isPermissionUpdate() {
            return isAPI(this, constAPI.teaching_schedule_update)
        },
        isPermissionDelete() {
            return isAPI(this, constAPI.teaching_schedule_delete)
        },
        addSchedule() {
            this.activePopup = true;
            this.isUpdate = false;
            this.teachingSchedule = {
                organizationBranchId: this.workshift.organizationBranchId,
                startTime: this.computedStartTime,
                endTime: this.computedEndTime
            }
            this.teachingSchedule.startTime = '08:00',
            this.teachingSchedule.endTime = '17:30',
            this.modelWork =   { value: 0, label: 'Cả ngày' },
            // this.colors.forEach(el => el.style = '20px');
            this.$validator.reset();
        },
        editSchedule(data) {
            this.teachingSchedule = {
                id: data.id,
                colorCode: data.colorCode,
                description: data.description,
                startTime: data.startTime,
                endTime: data.endTime,
                name: data.name,
                organizationId: data.organizationId,
                organizationBranchId: data.organizationBranchId
            };
            this.workshiftModel = this.listWorkShift.find(el => el.color == data.colorCode);
            this.getColorById(data.colorCode);
            this.activePopup = true;
            this.isUpdate = true;
            this.$store.commit('RELOAD_DATA', true);
        },
        removeSchedule(item) {
            this.teachingId = item.id;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá "${item.name}" không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$crm.post(`/teaching-schedule/delete/${this.teachingId}`).then(() => {
                this.getDataScheduleWorkshift();
                return this.$vs.notify({
                    text: 'Xoá thành công lịch làm việc',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success'
                });
            }).catch((err) => {
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        getDataScheduleWorkshift() {
            this.$vs.loading();
            this.$crm.post('/teaching-schedule/find-all', this.workshift).then((res) => {
                this.workshifts = res.data;
                this.$vs.loading.close();
            }).catch((err) => {
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        selectedColor: function (item, index) {
            for (let i = 0; i < this.colors.length; i++) {
                let classStyle = document.getElementsByClassName('cursor-pointer_' + i)[0];
                if (classStyle) {
                    classStyle.style.width = '20px';
                    classStyle.style.height = '20px';
                }
            }
            let classStyle = document.getElementsByClassName('cursor-pointer_' + index)[0];
            classStyle.style.width = '28px';
            classStyle.style.height = '28px';
            this.teachingSchedule.colorCode = item.hex;
        },
        async saveChanges() {
            const result = await this.$validator.validateAll();
            if (!result) return;
            if (this.teachingSchedule.startTime > this.teachingSchedule.endTime) {
                return this.$vs.notify({
                    text: 'Thời gian không hợp lệ',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }
            let url = !this.isUpdate ? '/teaching-schedule/create' : '/teaching-schedule/update';
            this.$vs.loading();
            this.teachingSchedule.type = 0;
            let obj = this.listWorkShift.find(el => el.value == this.workshift.valueWorkshift);
            this.teachingSchedule.name = this.workshiftModel
            if (!this.isUpdate) {
                this.teachingSchedule.name = this.workshiftModel.label.concat("_", obj.value);
                this.teachingSchedule.colorCode = obj.color;
            } else {
                let strName = this.workshiftModel.label.split('_');
                this.teachingSchedule.name = strName[0].concat("_", obj.value);
                this.teachingSchedule.colorCode = obj.color;
            }
            this.$crm.post(url, this.teachingSchedule).then(() => {
                this.activePopup = false;
                this.getDataScheduleWorkshift();
                this.$store.commit('RELOAD_DATA', true);
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        getColorById(colorOrigin) {
            this.colors.forEach(el => el.style = '20px')
            if (colorOrigin) {
                this.colors.forEach((item) => {
                    if (item.hex == colorOrigin) {
                        item.style = '28px';
                    }
                })
            }
        }
    },
    async created() {
        this.workshiftModel = this.listWorkShift[0];
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || []);
        branchList = branchList.filter(x => x.organizationBranchType !== 3).map(el => {
            return {
                label: el.organizationBranchName,
                value: el.id
            }
        })
        this.branchList = branchList;
        this.branchListOptions = branchList;
        this.workshift.organizationBranchId = branchList[0].value;
        this.getDataScheduleWorkshift();
    }
}
</script>

<style></style>
